import { useIntl } from "react-intl";
import { useUserMe } from "../../hooks";
import useCongress from "../../hooks/useCongress";

const useCongressLinks = (extraLinks = []) => {
  const intl = useIntl();
  const { congress } = useCongress();
  const { user } = useUserMe();

  const links = [
    {
      label: intl.formatMessage({ id: "Shared.BaseLayout.Agenda", defaultMessage: "Agenda" }),
      icon: "timetable",
      route: "/agenda",
      availableUnpublished: false
    },
    {
      label: intl.formatMessage({
        id: "Shared.BaseLayout.Favourites",
        defaultMessage: "Favourites"
      }),
      icon: "star",
      route: "/favourites",
      availableUnpublished: false
    }
  ];
  const filteredLinks = links
    .concat(extraLinks)
    .filter(x => user.hasRoles(["admin", "organizer"]) || congress.open || x.availableUnpublished);

  return filteredLinks;
};

const useLearnLinks = (extraLinks = []) => {
  const intl = useIntl();
  const { congress } = useCongress();
  const { user } = useUserMe();

  const links = [
    {
      label: intl.formatMessage({
        id: "Shared.BaseLayout.Favourites",
        defaultMessage: "Favourites"
      }),
      icon: "star",
      route: "/favourites",
      availableUnpublished: false
    }
  ];

  const filteredLinks = links
    .concat(extraLinks)
    .filter(x => user.hasRoles(["admin", "organizer"]) || congress.open || x.availableUnpublished);

  return filteredLinks;
};

const GetAvailableUserLinks = (extraLinks = []) => {
  const { congress } = useCongress();

  const congressLinks = useCongressLinks(extraLinks);
  const learnLinks = useLearnLinks(extraLinks);

  return congress.enableFeatureLearn ? learnLinks : congressLinks;
};

export default GetAvailableUserLinks;
